import React, { useState } from 'react';
import moment from "moment";
import { useMutation } from "@apollo/client";
import { Trans } from 'react-i18next';

import { reverseReceiveTime, validateInputDates } from '../../../Helpers/ReceiveTimeInArray';
import { UPDATE_BOOKING } from '../../../GraphQL/Mutations/bookings';

export const parseBookingFormInput = (bookingForm, calendarBooking) => {
    const { tempLocaleTime, extendedProps: { booking: gqlBooking } } = calendarBooking
    const { start_date, end_date, pick_up_time, drop_off_time, service_usage, vehicle_usage, notes } = bookingForm;
    const { type } = gqlBooking;

    const getIsoFromDateTime = (date, time) => moment(`${date} ${reverseReceiveTime(time)}`).format('YYYY-MM-DDTHH:mm:ssZ')

    const {
        scheduledReleasedAt,
        releaseTime,
        releaseDate,
        scheduledReturnedAt,
        returnTime,
        returnDate,
    } = tempLocaleTime

    return {
        id: parseInt(gqlBooking.id),
        // status: shouldApprove ? 'booked' : gqlBooking.status,
        scheduledReleasedAt: releaseTime && releaseDate ? scheduledReleasedAt : getIsoFromDateTime(releaseDate ?? start_date, releaseTime ?? pick_up_time),
        scheduledReturnedAt: returnTime && returnDate ? scheduledReturnedAt : getIsoFromDateTime(returnDate ?? end_date, returnTime ?? drop_off_time),
        serviceBookingPurpose: type === 'service' ? service_usage : undefined,
        // usageType: type === 'service' ? type : settings.vehicle_usage_types[vehicle_usage],
        specialRequestRemark: notes,
    }
}

export const EditBookingActionButtons = ({ endEdit, submitEdit, booking, settings, stakeholder }) => {
    // const [updateBookingMutation, { data, loading, error }] = useMutation(UPDATE_BOOKING);

    const [loadingUpdate, setLoadingUpdate] = useState(false);

    const shouldApprove = booking.Book_Status >= 3 || booking.status === 'pending';

    // const parseBookingFormInput = (bookingForm, calendarBooking) => {
    //     const { tempLocaleTime, extendedProps: { booking: gqlBooking } } = calendarBooking
    //     const { start_date, end_date, pick_up_time, drop_off_time, service_usage, vehicle_usage, notes } = bookingForm;
    //     const { type } = gqlBooking;

    //     const getIsoFromDateTime = (date, time) => moment(`${date} ${reverseReceiveTime(time)}`).format('YYYY-MM-DDTHH:mm:ssZ')

    //     const {
    //         scheduledReleasedAt,
    //         releaseTime,
    //         releaseDate,
    //         scheduledReturnedAt,
    //         returnTime,
    //         returnDate,
    //     } = tempLocaleTime

    //     return {
    //         id: parseInt(gqlBooking.id),
    //         status: shouldApprove ? 'booked' : gqlBooking.status,
    //         scheduledReleasedAt: releaseTime && releaseDate ? scheduledReleasedAt : getIsoFromDateTime(releaseDate ?? start_date, releaseTime ?? pick_up_time),
    //         scheduledReturnedAt: returnTime && returnDate ? scheduledReturnedAt : getIsoFromDateTime(returnDate ?? end_date, returnTime ?? drop_off_time),
    //         serviceBookingPurpose: type === 'service' ? service_usage : undefined,
    //         usageType: type === 'service' ? type : settings.vehicle_usage_types[vehicle_usage],
    //         specialRequestRemark: notes,
    //     }
    // }

    // [not in use due to queue data sync implementation]
    const updateBookingGraphQL = (bookingForm, calendarBooking, closeEdit) => {
        // const bookingInput = parseBookingFormInput(bookingForm, calendarBooking);

        // // TODO: remove this workaround when we remove the legacy API (we'll have the correct time string)
        // const parsedBookingInput = validateInputDates(bookingInput, booking.extendedProps.booking);

        // updateBookingMutation({ variables: { input: parsedBookingInput } }).then((response) => {
        //     showStatusMsg('Booking changes saved successfully', 'success');

        //     const { calendarRef, event, ...booking } = calendarBooking;

        //     // [not in use due to queue data sync implementation]
        //     // const currentBooking = {
        //     //     ...booking,
        //     //     extendedProps: {
        //     //         ...booking.extendedProps,
        //     //         booking: {
        //     //             ...booking.extendedProps.booking,
        //     //             ...parsedBookingInput,
        //     //         }
        //     //     }
        //     // }
        //     // localStorage.setItem('currentBooking', JSON.stringify(currentBooking));
        //     // window.location.reload();
        // }).catch((error) => {
        //     // [not in use due to queue data sync implementation]
        //     // setLoadingUpdate(false);
        //     console.error('[updateBookingMutation] error: ', error);
        // });
    }

    const updateBooking = () => {
        // TODO: remove update booking graphql
        setLoadingUpdate(true);
        return submitEdit(updateBookingGraphQL, setLoadingUpdate)
    };

    const discardChanges = () => endEdit()

    return (
        <div className="booking_bottom border-top">
            <button className="button" onClick={discardChanges}>
                <Trans>Discard Changes</Trans>
            </button>
            <button className="button approve ml-16" onClick={updateBooking} disabled={loadingUpdate}>
                <Trans>{shouldApprove ? 'Approve' : 'Submit'}</Trans>
            </button>
        </div>
    )
}